import React from "react";
import { Box, Typography } from "@mui/material";

const AssignmentsDashboard = ({ message = "No content available" }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      minHeight="300px" // You can adjust this as per your layout
    >
      <Typography variant="h6" color="textSecondary">
        {message}
      </Typography>
    </Box>
  );
};

export default AssignmentsDashboard;
